import { keyToActionTypes } from 'src/utils/keyToActionTypes';

export const actionTypes: any = keyToActionTypes(
  {
    GET_FIRST_FETCH: null,
    DATA_FETCHED: null,
    GET_TOTAL_COUNT: null,
    SORT_TABLE: null,
    RESET_DATA: null,
    SELECT_ROW: null,
    LOAD_MORE: null,
    // Filter Actions
    UPDATE_SELECTED_ITEMS: null,
    CLEAR_SELECTED_ITEMS: null,
  },
  'REPORTS'
);
